import { render, staticRenderFns } from "./teamAward.vue?vue&type=template&id=bbd84a82&scoped=true&"
import script from "./teamAward.vue?vue&type=script&lang=js&"
export * from "./teamAward.vue?vue&type=script&lang=js&"
import style0 from "./teamAward.vue?vue&type=style&index=0&id=bbd84a82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd84a82",
  null
  
)

export default component.exports